import styled from "styled-components";
import { Link as LinkRouter } from "react-router-dom";

export const FooterWrapper1 = styled.footer`
    padding: 72px 100px 100px;

    @media screen and (min-width: 1440px){
        margin: auto;
        width: 1440px;
    }

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        padding: 67px 50px 50px;
    }

    @media screen and (max-width: 768px){
        padding: 67px 24px 50px;
    }
`;

export const FooterWrapper2 = styled.div`
    // display: grid;
    // grid-gap: 1rem;
    // grid-template-columns: repeat(auto-fill,minmax(21rem,1fr));
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media screen and (max-width: 1023px){
        flex-direction: column;
    }
`;

export const FooterLogo = styled(LinkRouter)`
    color: var(--white);
    display: flex;
    align-items: center;
    justify-self: flex-start;
    cursor: pointer;
    text-decoration: none;
    padding-bottom: 87px;

    @media screen and (max-width: 1023px){
        padding-bottom: 48px;
        display: flex;
        justify-content: center;
    }
`;

export const FooterComP = styled.p`
    padding-bottom: 32px;
    font-family: Archivo;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: var(--white);

    @media screen and (max-width: 1023px){
        font-size: 12px;
        line-height: 15px;
        padding-bottom: 17px;
    }
`;

export const TermCond = styled.p`
    font-family: Archivo;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: var(--white);

    @media screen and (max-width: 1023px){
        font-size: 12px;
        line-height: 15px;
    }
`;

export const SupportLink = styled.p`
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: var(--white);
    padding-bottom: 54px;

    @media screen and (max-width: 1023px){
        font-size: 13px;
        line-height: 17px;
        padding-bottom: 31px;
    }
`;

export const LastSupportLink = styled(SupportLink)`
    padding-bottom: 0
`;

export const SocialMedia = styled.div`
    padding-bottom: 10px;
`;

export const LastSocialMedia = styled(SocialMedia)`
    padding-bottom: 0;
`;